<div class="modal--group-replaement">
  <h1 class="modal__header">Replacement Policy</h1>
  <p>Is {{ policyNumber }} a group coverage policy from an employer?</p>
  <div class="modal__actions modal__actions--inline" style="justify-content: space-evenly">
    <button class="button button--blue button--primary modal__button" (click)="confirm()">Yes</button>
    <button class="button button--blue button--primary modal__button" (click)="cancel()">No</button>
  </div>
</div>
